import {useSearchOptions} from "../../../hooks/useSearchOptions";
import {orgsListURL} from "./organizationTable.constants";

export const useOrganizationSearchOptions = () => {
  const options = useSearchOptions(orgsListURL, ["name", "slug"]);

  const searchOptions = [
    {
      category: {label: "Name", value: "name"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.name,
    },
    {
      category: {label: "Slug", value: "slug"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.slug,
    },
  ];

  return {searchOptions};
};
